import { beginTask, endTask } from 'redux-nprogress';
import { pick, isEqual } from 'lodash';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectCurrent, loadWeeks } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'TeamRanksMatchups';
export const selectTeamRanksMatchupsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  matchups: [],
  year: null,
  showStart: null,
  showEnd: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const teamRanksMatchupsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default teamRanksMatchupsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_TEAM_PRM_REQUEST = `${STORE_KEY}/LOAD_TEAM_PRM_REQUEST`;
export const LOAD_TEAM_PRM_SUCCESS = `${STORE_KEY}/LOAD_TEAM_PRM_SUCCESS`;
export const LOAD_TEAM_PRM_ERROR = `${STORE_KEY}/LOAD_TEAM_PRM_ERROR`;
export const SET_TEAM_PRM_SHOWRANGE = `${STORE_KEY}/SET_TEAM_PRM_SHOWRANGE`;

export const loadTeamRanksMatchupsRequest = ({
  year,
  formulaId,
  showStart,
  showEnd,
}) => ({
  type: LOAD_TEAM_PRM_REQUEST,
  payload: {
    year,
    formulaId,
    showStart,
    showEnd,
  },
});

export const setTeamPRMShowRange = range => ({
  type: SET_TEAM_PRM_SHOWRANGE,
  payload: { showStart: range.min, showEnd: range.max },
});

export const loadTeamRanksMatchupsSuccess = (matchups) => ({
  type: LOAD_TEAM_PRM_SUCCESS,
  payload: { matchups },
});
export const loadTeamRanksMatchupsError = error => ({
  type: LOAD_TEAM_PRM_ERROR,
  payload: { error },
});

actions[LOAD_TEAM_PRM_REQUEST] = (
  state,
  {
    payload: {
      year,
      formulaId,
      showStart,
      showEnd,
    },
  },
) => ({
  ...state,
  year,
  formulaId,
  showStart,
  showEnd,
});

actions[LOAD_TEAM_PRM_SUCCESS] = (state, { payload: { matchups } }) => ({
  ...state,
  matchups,
  hasLoaded: true,
});

actions[LOAD_TEAM_PRM_ERROR] = (state, { payload }) => ({
  ...state,
  error: payload.error,
});

actions[SET_TEAM_PRM_SHOWRANGE] = (state, { payload }) => ({
  ...state,
  ...payload,
});

export const loadTeamRanksMatchups = params => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(
      loadTeamRanksMatchupsRequest(params),
    );
    const response = await api.rankings.getTeamRanksMatchups(params);
    dispatch(loadTeamRanksMatchupsSuccess(response.team_ranks_matchups));
  } catch (error) {
    console.error(error);
    dispatch(loadTeamRanksMatchupsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const TEAM_PRM_VIEW = `${STORE_KEY}/TEAM_PRM_VIEW`;
viewNames[TEAM_PRM_VIEW] = 'TeamRanksMatchups';
routes[TEAM_PRM_VIEW] = {
  path: '/stats/team-position-rank-matchups',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let {
      year,
      formulaId,
      showStart,
      showEnd,
    } = selectQuery(state);
    const currentWeek = selectCurrent(state, 'stats').week;
    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = selectCurrent(state, 'stats').season;
    if (!showStart) showStart = 1;
    if (!showEnd) {
      const weeks = await dispatch(loadWeeks(year));
      // const endWeek = weeks.payload.weeks.active_week;
      const endWeek = typeof weeks !== 'undefined' ? weeks.payload.weeks.active_week : (year >= 2021 ? 18 : 17);
      showEnd = (currentWeek >= 17) ? 17 : endWeek;
    }

    await dispatch(
      loadTeamRanksMatchups({
        year,
        formulaId,
        showStart,
        showEnd,
      }),
    );
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRanksMatchups/module/teamPRM.js